import { render } from "./Header.vue?vue&type=template&id=b7e65a04"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=b7e65a04&lang=css&soped=true"

import exportComponent from "/media/gubbi/51C0A8CA04B85949/Ubuntu/home/tp/e-menu/2.0.0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__